<script>
const IMAGE_EXT = ["jpg", "jpeg", "png", "gif", "webp"];

function getExt(str) {
  const clean = String(str || "").split("?")[0].split("#")[0];
  const match = clean.match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : "";
}

export default {
  name: "FileViewerModal",
  props: {
    value: { type: Boolean, default: false },
    url:   { type: String,  default: "" },
    name:  { type: String,  default: "" },
    title: { type: String,  default: "Visualizar Arquivo" },
  },
  computed: {
    ext() {
      return getExt(this.name) || getExt(this.url);
    },
    isImage() {
      return IMAGE_EXT.includes(this.ext);
    },
    isPdf() {
      return this.ext === "pdf";
    },
  },
};
</script>

<template>
  <b-modal :visible="value" :title="title" hide-footer size="lg" centered @change="$emit('input', $event)">
    <div v-if="url" class="text-center">
      <img v-if="isImage" :src="url" class="img-fluid rounded" style="max-height:70vh;" />
      <iframe v-else-if="isPdf" :src="url" style="width:100%;height:70vh;border:0;"></iframe>
      <p v-else class="text-muted py-4 mb-0">
        Não foi possível pré-visualizar este tipo de arquivo.
      </p>
      <div class="mt-3">
        <a :href="url" target="_blank" rel="noopener" class="btn btn-sm btn-outline-secondary">
          <i class="mdi mdi-open-in-new mr-1"></i> Abrir em nova aba
        </a>
      </div>
    </div>
  </b-modal>
</template>
